module.exports = __webpack_public_path__ + "static/img/ideaImg1.9d35c11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/ideaImg1.png
// module id = NHSB
// module chunks = 0